import React from 'react'
import { useTranslation } from 'react-i18next'

// MUI Imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'

const StartMailingConfirmDialog = ({
  open,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
    >
      <DialogTitle>
        {t('mailTemplate.campaignReview.confirmStartMailing.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('mailTemplate.campaignReview.confirmStartMailing.message')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {t('mailTemplate.campaignReview.confirmStartMailing.cancel')}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained" autoFocus>
          {t('mailTemplate.campaignReview.confirmStartMailing.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default StartMailingConfirmDialog
